import { useOpenRecalls } from '~/context/vdp/VehicleContext';
import useIsInExclusivePreview from '~/hooks/vdp/selectors/useIsInExclusivePreview';
import useIsReservableVehicle from '~/hooks/vdp/selectors/useIsReservableVehicle';

export default function useShouldImport() {
  const isInExclusivePreview = useIsInExclusivePreview() || false;
  const isReservable = useIsReservableVehicle();
  const recalls = useOpenRecalls();

  const importRecalls = recalls.length > 0;
  const importReservableHeader = isReservable || isInExclusivePreview;

  return {
    importRecalls,
    importReservableHeader
  };
}
